var map = {
	"./Blood.png": 13345,
	"./Icons.png": 1875,
	"./Motion.png": 53687,
	"./None.png": 44615,
	"./Plasma.png": 99963,
	"./Serum.png": 86349,
	"./Sputum.png": 65677,
	"./Stool.png": 90904,
	"./Tick-icon.png": 70894,
	"./Urine.png": 95452,
	"./blood-collection.png": 45596,
	"./bookmark.png": 48713,
	"./cash.png": 31056,
	"./check-in.png": 78653,
	"./ct-scanner.png": 52805,
	"./ct.png": 30739,
	"./external-clinic-infirmary-flat-obvious-flat-kerismaker-38.png": 29384,
	"./external-danger-security-flaticons-flat-flat-icons.png": 81360,
	"./external-doctor-hospital-and-medical-justicon-flat-justicon.png": 60441,
	"./external-history-computer-programming-icons-flaticons-lineal-color-flat-icons.png": 76629,
	"./external-lab-back-to-school-flat-02-chattapat-.png": 27012,
	"./external-medicine-travel-accessories-icongeek26-flat-icongeek26.png": 38715,
	"./guest.png": 11501,
	"./hospital-bed.png": 47005,
	"./oral.png": 87705,
	"./radio.png": 41548,
	"./radiology1.png": 83642,
	"./swab.png": 81362,
	"./waiting-room.png": 74418,
	"./xray.png": 32057
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85994;